(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choko-category-refinements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('choko-category-refinements')) {
    customElements.define('choko-category-refinements', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const preserveQuery = (link) => {
          const destination = new URL(link.getAttribute('href'), window.location.origin);
          destination.search = window.location.search;
          destination.searchParams.delete('page');
          if (link.hasAttribute('data-choko-clear')) {
            for (const key of [...destination.searchParams.keys()]) {
              if (key.startsWith('filter.')) destination.searchParams.delete(key);
            }
          }
          link.href = destination.href;
        };
        this.querySelectorAll('[data-choko-refinement]').forEach(preserveQuery);
        this.updateState = () => {
          const params = new URLSearchParams(window.location.search);
          const clear = this.querySelector('[data-choko-clear]');
          const active = window.location.pathname.replace(/\/$/, '') !== new URL(clear.href).pathname.replace(/\/$/, '') || [...params.keys()].some(key => key.startsWith('filter.'));
          this.querySelectorAll('[data-choko-clear]').forEach(link => { link.hidden = !active; });
        };
        this.updateState();
        const grid = document.getElementById('ProductGridContainer');
        if (grid) { this.observer = new MutationObserver(this.updateState); this.observer.observe(grid, {childList:true}); }
        window.addEventListener('popstate', this.updateState);
        const preservePaginationQuery = (link) => {
          const destination = new URL(link.getAttribute('href'), window.location.origin);
          const nextPage = destination.searchParams.get('page');
          destination.search = window.location.search;
          if (nextPage) destination.searchParams.set('page', nextPage);
          link.href = destination.href;
        };
        document.querySelectorAll('.pagination a[href]').forEach(preservePaginationQuery);
        this.onPaginationInteraction = (event) => {
          const link = event.target.closest('.pagination a[href]');
          if (link) preservePaginationQuery(link);
        };
        ['click', 'focusin', 'pointerover'].forEach((eventName) => {
          document.addEventListener(eventName, this.onPaginationInteraction, true);
        });
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-choko-refinement]');
          if (link && this.contains(link)) preserveQuery(link);
        });
        this.addEventListener('toggle', (event) => {
          if (!event.target.matches('details[open]')) return;
          this.querySelectorAll('details[open]').forEach((other) => {
            if (other !== event.target) other.open = false;
          });
        }, true);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const openGroup = event.target.closest('details[open]');
          if (openGroup) {
            openGroup.open = false;
            openGroup.querySelector('summary').focus();
          }
        });
      }
      disconnectedCallback() {
        if (!this.onPaginationInteraction) return;
        ['click', 'focusin', 'pointerover'].forEach((eventName) => {
          document.removeEventListener(eventName, this.onPaginationInteraction, true);
        });
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('popstate', this.updateState);
        delete this.dataset.initialized;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choko-gift-filters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('choko-gift-filters')) {
    customElements.define('choko-gift-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const prepareLink = (link) => {
          const destination = new URL(link.getAttribute('href'), window.location.origin);
          destination.search = window.location.search;
          destination.searchParams.delete('page');
          if (link.hasAttribute('data-gift-budget')) {
            destination.pathname = window.location.pathname;
            destination.searchParams.delete('filter.v.price.gte');
            destination.searchParams.delete('filter.v.price.lte');
            if (link.dataset.min) destination.searchParams.set('filter.v.price.gte', link.dataset.min);
            if (link.dataset.max) destination.searchParams.set('filter.v.price.lte', link.dataset.max);
          }
          if (link.hasAttribute('data-gift-clear')) {
            for (const key of [...destination.searchParams.keys()]) {
              if (key.startsWith('filter.')) destination.searchParams.delete(key);
            }
          }
          link.href = destination.href;
        };
        this.querySelectorAll('[data-gift-tag],[data-gift-budget],[data-gift-clear]').forEach(prepareLink);
        this.updateState = () => {
          const params = new URLSearchParams(window.location.search);
          const amount = (key) => { const value = params.get(key); return value && Number.isFinite(Number(value)) ? String(Number(value)) : ''; };
          const minimum = amount('filter.v.price.gte');
          const maximum = amount('filter.v.price.lte');
          const budgets = [...this.querySelectorAll('[data-gift-budget]')];
          const selected = budgets.find((link) => (link.dataset.min || '') === minimum && (link.dataset.max || '') === maximum);
          budgets.forEach((link) => {
            if (link === selected) link.setAttribute('aria-current', 'page');
            else link.removeAttribute('aria-current');
          });
          this.querySelector('[data-gift-budget-label]').textContent = selected ? selected.textContent : this.querySelector('[data-gift-custom-budget]').textContent;
          const active = window.location.pathname.replace(/\/$/, '') !== new URL(this.querySelector('[data-gift-clear]').href).pathname.replace(/\/$/, '') || [...params.keys()].some((key) => key.startsWith('filter.'));
          this.querySelectorAll('[data-gift-clear]').forEach((link) => { link.hidden = !active; });
        };
        this.updateState();
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-gift-tag],[data-gift-budget],[data-gift-clear]');
          if (link && this.contains(link)) prepareLink(link);
          this.updateState();
        });
        this.addEventListener('toggle', (event) => {
          if (!event.target.matches('details[open]')) return;
          this.updateState();
          this.querySelectorAll('details[open]').forEach((other) => { if (other !== event.target) other.open = false; });
        }, true);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const group = event.target.closest('details[open]');
          if (group) { group.open = false; group.querySelector('summary').focus(); }
        });
        this.onPagination = (event) => {
          const link = event.target.closest('.pagination a[href]');
          if (!link) return;
          const destination = new URL(link.href);
          const page = destination.searchParams.get('page');
          destination.search = window.location.search;
          if (page) destination.searchParams.set('page', page);
          link.href = destination.href;
        };
        ['click','focusin','pointerover'].forEach((name) => document.addEventListener(name, this.onPagination, true));
        window.addEventListener('popstate', this.updateState);
      }
      disconnectedCallback() {
        ['click','focusin','pointerover'].forEach((name) => document.removeEventListener(name, this.onPagination, true));
        window.removeEventListener('popstate', this.updateState);
        delete this.dataset.initialized;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
